module.exports = __webpack_public_path__ + "img/product_yellow.6c8fd8f7.svg";